import React, { Component } from "react";
import "./login.scss";
import {Form, Button, Container, Col, Row} from "react-bootstrap"
import PropTypes from "prop-types";
// import Api from "../../common/api"
import IdentityService from "../../common/identityService"
import { Redirect } from "react-router-dom";

export default class Login extends Component{
    constructor(props) {
        super(props);
        this.state = {
          email: "",
          password: "",
          loginClicked: false
        };
    }
    
      async componentDidMount() {
        this.props.setDisplayMenu(false)
        try {
            const isLoggedIn = await IdentityService.isLoggedIn();
            this.setState({
              isLoggedIn: isLoggedIn,
            });
        } catch (e) {
            this.props.notifyFailure(
                "Failed to login. Error: " + JSON.stringify(e.message),
                3000
            );
            console.log("Failed to login. Error: " + JSON.stringify(e));
        }
      }
    
      async componentDidUpdate(prevProps, prevState) {
        if (prevState.loginClicked === false && this.state.loginClicked === true) {
          try {
            await IdentityService.authenticate(
              this.state.email,
              this.state.password
            );
            this.props.setIsLoggedIn(true);
            // const userInfo = await Api.getLoggedInUser();
            window.location.reload(false);
          } catch (e) {
            this.props.notifyFailure(
              "Failed to login. Error: " + JSON.stringify(e.message),
              3000
            );
            console.log("Failed to login. Error: " + JSON.stringify(e));
          }
          this.setState({
            loginClicked: false
          });
        }
      }

      componentWillUnmount(){
          this.props.setDisplayMenu(true)
      }

    onLoginClicked = event => {
        this.setState({
            loginClicked: true
        });
        event.preventDefault();

    };

    render() {
        if (this.state.isLoggedIn){
            return(
                <Redirect
                    to="/profile"
                />
            );
        } else {
            return(this.renderLoginForm());
        }
        
    }
    
    renderLoginForm() {
      return(
          <Container className="child-container">
          <Form 
              className="pt-5"
              onSubmit={async event => {
                  await this.onLoginClicked(event);
              }}
          >
              <Form.Group controlId="formBasicEmail">
                  <Form.Label>Username:</Form.Label>
                  <Form.Control 
                      type="email" 
                      placeholder="Enter email" 
                      onChange={event=> {
                          this.setState({
                              email: event.target.value
                          });
                      }}    
                  />
              </Form.Group>
              <Form.Group controlId="formBasicPassword">
                  <Form.Label>Password:</Form.Label>
                  <Form.Control 
                      type="password"
                      placeholder="Password" 
                      onChange={event => {
                          this.setState({
                              password: event.target.value
                          });
                      }}
                      onKeyPress={async event => {
                          if (event.key === "Enter") {
                              this.onLoginClicked(event);
                          }
                      }}
                  />
              </Form.Group>
              {/* <Form.Group controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" label="Remember me" />
              </Form.Group> */}
              <Row className="justify-content-center pr-3 pl-3">
              <Button className="w-100" variant="primary" type="submit">
                  Login
              </Button>
              </Row>
              <Row>
              <Col className="text-left">
                      <Button href="/#" className="btn-sm btn-link" variant>Forgot password</Button>
                  </Col>
                  <Col className="text-right">
                      <Button href="/registration" className="btn-sm btn-link" variant>Sign up</Button>
                  </Col>
              </Row>
          </Form>
          </Container>
      );
  }
}

Login.propTypes = {
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};